import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f8e25328"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "material-item"
};
const _hoisted_2 = {
  class: "right"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  class: "author"
};
const _hoisted_5 = {
  class: "college"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, {
    class: "left",
    src: $props.itemData.fileUrl,
    fit: "cover"
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($props.itemData.name || '-'), 1), _createElementVNode("div", _hoisted_4, _toDisplayString($props.itemData.author_name || '-'), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($props.itemData.organ_name), 1)])]);
}